interface CreateStreamInput {
  id?: number;
  stream_type?: string;
  stream_url?: string;
  language?: string;
  order?: string;
  button?: string;
  button_en?: string;
}

export default function live(axios: any) {
  /**
   * LIVE API
   * */
  const getLives = async () => {
    const result = await axios.get('/sessions').then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const getLive = async (id: number | string) => {
    const result = await axios.get(`/sessions/${id}`).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const createLive = async (payload: any) => {
    const result = await axios.post('/sessions', {
      ...payload,
    }).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const updateLive = async (id: number, payload: any) => {
    const result = await axios.put(`/sessions/${id}`, {
      ...payload,
    }).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const deleteLive = async (id: number) => {
    const result = await axios.delete(`/sessions/${id}`).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return response;
    });
    return result;
  };

  const updateLiveModuleStatus = async (
    id: number | string,
    moduleName: string,
    status: any,
  ) => {
    const body = {};
    /* eslint-disable */
    if (moduleName === 'enablePoll') (body as any).enable_poll = status as boolean;
    else if (moduleName === 'enableQuestion') (body as any).enable_question = status as boolean;
    else if (moduleName === 'enableChat') (body as any).enable_chat = status as boolean;
    else if (moduleName === 'enableStore') (body as any).enable_store = status as boolean;
    else if (moduleName === 'showAgenda') (body as any).show_agenda = status;
    /* eslint-enable */
    const result = await axios.put(`/sessions/${id}`, body).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return 'error';
    });
    return result;
  };

  /**
   * Stream
   */
  const createStream = async (
    liveId: number | string,
    payload: CreateStreamInput,
  ) => {
    const result = await axios.post(`/sessions/${liveId}/streams`, payload).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return 'error';
    });
    return result;
  };

  const updateStream = async (
    id: number,
    payload: CreateStreamInput,
  ) => {
    const result = await axios.put(`/streams/${id}`, payload).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return 'error';
    });
    return result;
  };

  const deleteStream = async (
    id: number | string,
  ) => {
    const result = await axios.delete(`/streams/${id}`).then((response: any) => {
      if (response.status === 200) {
        return response.data;
      }
      return 'error';
    });
    return result;
  };

  return {
    getLives,
    getLive,
    createLive,
    updateLive,
    deleteLive,
    updateLiveModuleStatus,
    createStream,
    updateStream,
    deleteStream,
  };
}
